/**
 * @Description
 */

import { FC, useEffect, useMemo, useRef, useState } from 'react';
import styles from './index.module.less';
import Header from '../Header';
// import { Col, Row } from 'antd';
import { IconFont } from '@/components';
// import PPTRadarChart from '../RadarChart';
import PPTMap from '../Map';
import { useMethods } from '@lhb/hook';
import cs from 'classnames';

const PageTwo:FC<any> = ({
  rangeName,
  lnglat,
  reportConclusion,
  range,
  recommendRange,
  poiName,
  // isSurrounding
}) => {

  const mapRef: any = useRef();

  const [mapIns, setMapIns] = useState<any>();

  const methods = useMethods({
    onMapReady(_mapIns) {
      setMapIns(_mapIns);
    },
  });

  useEffect(() => {
    if (recommendRange) {
      if (!mapIns || !lnglat?.lng || !lnglat?.lat || !range) return;
      mapRef?.current?.addMarkerCircle(lnglat?.lng, lnglat?.lat, range, recommendRange);
      mapRef?.current?.addCircle(lnglat?.lng, lnglat?.lat, recommendRange);
    } else {
      if (!mapIns || !lnglat?.lng || !lnglat?.lat || !range) return;
      mapRef?.current?.addMarkerCircle(lnglat?.lng, lnglat?.lat, range);
    }

  }, [mapIns, lnglat, recommendRange]);

  const detailData = useMemo(() => {
    const data = [
      { icon: 'iconic_renkoumidu', title: '人口客群:', detail: reportConclusion?.peopleInfo?.introduction || '' },
      { icon: 'iconic_jiaotong', title: '区域特征:', detail: reportConclusion?.regionInfo?.introduction || '' },
      { icon: 'iconic_xiaofei', title: '消费能力:', detail: reportConclusion?.consumptionAbility?.introduction || '' },
      { icon: 'iconxingzhuang1', title: '门店经营:', detail: reportConclusion?.storeOperation?.introduction || '' },
    ];
    return data;
  }, [reportConclusion]);

  const scoreData = useMemo(() => {
    return [
      { score: reportConclusion?.peopleInfo?.score || '-', name: '人口客群' },
      { score: reportConclusion?.regionInfo?.score || '-', name: '区域特征' },
      { score: reportConclusion?.consumptionAbility?.score || '-', name: '消费能力' },
      // { score: reportConclusion?.storeOperation?.score || '-', name: '门店经营' },
    ];
  }, [reportConclusion]);

  return (
    <div className={styles['page']}>
      <Header title={`整体市场评估 — ${rangeName}`}/>

      <div className={styles['content']}>
        <div className={styles['left']}>

          <div className={styles['left-top']}>
            <div className={styles['sum']}>
              <div className={styles['sum-title']}>市场评分</div>
              <div className={styles['sum-score']}>{reportConclusion?.score || '-'}</div>
              <div className={styles['sum-appraisal']}>{reportConclusion?.introduction || '-'}</div>
            </div>

            <div className={styles['detail']}>
              {scoreData.map((item, index) => {
                return (
                  <div className={styles['item']} key={index}>
                    <div className={styles['item-score']}>{item.score}</div>
                    <div className={styles['item-name']}>{item.name}</div>
                  </div>
                );
              })}
            </div>

            <div className={styles['comment']}>
              {reportConclusion?.description || '-'}
            </div>
          </div>

          <div className={styles['left-center']}>
            {detailData.map((item, index) => {
              return (
                item.detail ? <div className={styles['block']} key={index}>
                  <div className={styles['block-left']}>
                    <IconFont iconHref={item.icon} className={styles['icon']}/>
                  </div>

                  <div className={styles['block-content']} style={{ maxWidth: index === 2 ? '585px' : '563px' }} ><span className={styles['title']}>{item.title}</span>{item.detail}</div>
                </div> : ''
              );
            })}
          </div>

          {/* 0201不上-雷达图 */}
          {/* <div className={styles['left-bottom']}>
            <div className={styles['chart']}>
              <PPTRadarChart
                height={377}
                width={'100%'}
                indicator={[
                  { name: '人口密度', max: 10 },
                  { name: '交通便利', max: 10 },
                  { name: '门店经营', max: 10 },
                  { name: '消费水平', max: 10 },
                  { name: '配套完善度', max: 10 },
                ]}
                seriesData={[{
                  value: [9.1, 8.5, 8.7, 9.3, 8.9],
                }]}
              />
            </div>
          </div> */}

          {reportConclusion?.density?.introduction ? <div className={styles['left-bottom']}>
            <span className={styles['title']}>{`${reportConclusion?.density?.categoryName}密度:`}</span>{reportConclusion?.density?.introduction || '-'}
          </div> : ''}
        </div>

        <div className={styles['right']}>
          <div className={styles['map']}>
            <PPTMap
              height={recommendRange ? 758 : 848}
              ref={mapRef}
              onMapReady={methods.onMapReady}
              poiName={poiName}/>
          </div>
          {recommendRange ? <div className={styles['legend']}>
            <div className={styles['item']}>
              <div className={cs(styles['item-icon'], styles['blue'])}/>
              <div className={styles['item-title']}>推荐位置：{recommendRange}m</div>
            </div>
            <div className={styles['item']}>
              <div className={cs(styles['item-icon'], styles['orange'])}/>
              <div className={styles['item-title']}>辐射范围：{range}m</div>
            </div>
          </div> : <></>}
        </div>
      </div>
    </div>
  );
};

export default PageTwo;
